
export enum DataTypeTranslationKey {
    AT_LEAST_ONE_ENUM_VALUE_IS_REQUIRED = "dataType.atLeastOneEnumValueIsRequired",
    AT_LEAST_ONE_OF_MIN_OR_MAX_MUST_BE_SPECIFIED = "dataType.atLeastOneOfMinOrMaxMustBeGiven",
    AT_LEAST_ONE_OF_TIME_FROM_OR_TIME_TO_MUST_BE_SPECIFIED = "dataType.atLeastOneOfTimeFromOrTimeToMustBeGiven",
    AT_LEAST_ONE_OF_DATE_TIME_FROM_OR_DATE_TIME_TO_MUST_BE_SPECIFIED = "dataType.atLeastOneOfTDateTimeFromOrDateTimeToMustBeGiven",
    CHARACTERS = "dataType.characters",
    CONSTRAINTS = "dataType.constraints",
    CONSTRAINT_DELETED_SUCCESSFULLY = "dataType.constraintDeletedSuccessfully",
    CONSTRAINT_EXPRESSION= "dataType.constraintExpression",
    CONSTRAINTS_NAMES_MUST_BE_UNIQUE = "dataType.constraintNamesMustBeUnique",
    CONSTRAINT_TYPE = "dataType.constraintType",
    CONSTRAINT_WILL_BE_DELETED = "dataType.constraintWillBeDeleted",
    CORE_DATA_TYPE = "dataType.coreDataType",
    DATA_TYPE = "dataType.dataType",
    DATA_TYPES = "dataType.dataTypes",
    DATA_TYPE_CREATED_SUCCESSFULLY = "dataType.dataTypeCreatedSuccessfully",
    DATA_TYPE_DELETED_SUCCESSFULLY = "dataType.dataTypeDeletedSuccessfully",
    DATA_TYPE_IS_IN_USE_BY_ATTRIBUTES_IN_STEREOTYPES = "dataType.dataTypeIsInUseByAttributesInStereotypes",
    DATA_TYPE_WILL_BE_DELETED = "dataType.dataTypeWillBeDeleted",
    DATE_TIME_FROM = "dataType.dateTimeFrom",
    DATE_TIME_TO = "dataType.dateTimeTo",
    DATE_TIME_FROM_VALUE_MUST_BE_LESS_THAN_OR_EQUAL_TO_DATE_TIME_TO = "dataType.dateTimeFromValueMustBeLessThanOrEqualToDateTimeTo",
    DELETE_CONSTRAINT_PROMPT = "dataType.deleteConstraintPrompt",
    DELETE_DATA_TYPE_PROMPT = "dataType.deleteDataTypePrompt",
    DETAILS = "dataType.details",
    EDIT_DATA_TYPE = "dataType.editDataType",
    ENTER_VALID_REGULAR_EXPRESSION_PATTERN = "dataType.enterValidRegularExpressionPattern",
    ENUMERATION_VALUES = "dataType.enumerationValues",
    ENUMERATION_VALUE_MUST_BE_A_NUMBER = "dataType.enumerationValueMustBeANumber",
    INVALID_INPUT_FORMAT = "dataType.invalidFormat",
    INVALID_TIME_FROM = "dataType.invalidTimeFrom",
    INVALID_TIME_TO = "dataType.invalidTimeTo",
    MAX_CHARACTERS = "dataType.maxCharacters",
    MAX_VALUE = "dataType.maxValue",
    MIN_CHARACTERS = "dataType.minCharacters",
    MIN_LENGTH_MUST_BE_GREATER_THAN_OR_EQUAL_TO_ZERO = "dataType.minLengthMustBeGreaterThanOrEqualToZero",
    MIN_VALUE = "dataType.minValue",
    MIN_VALUE_MUST_BE_LESS_THAN_OR_EQUAL_TO_MAX = "dataType.minValueMustBeLessThanOrEqualToMax",
    NAME = "dataType.name",
    NEW_CONSTRAINT = "dataType.newConstraint",
    NEW_DATA_TYPE = "dataType.newDataType",
    NO_PATTERN_TO_TEST = "dataType.noPatternToTest",
    NUMBER_OF_CONSTRAINTS = "dataType.numberOfConstraints",
    PATTERN_DOES_NOT_MATCH = "dataType.patternDoesNotMatch",
    PATTERN_MATCHES = "dataType.patternMatches",
    REGULAR_EXPRESSION_IS_INVALID = "dataType.regularExpressionIsInvalid",
    REGULAR_EXPRESSION_PATTERN = "dataType.regularExpressionPattern",
    STRING_LENGTH_MUST_NOT_BE_ZERO="dataType.stringLengthMustNotBeZero",
    TEST_PATTERN = "dataType.testPattern",
    TEST_VALUE = "dataType.testValue",
    TIME_FROM = "dataType.timeFrom",
    TIME_FROM_MUST_BE_BEFORE_TIME_TO = "dataType.timeFromMustBeBeforeTimeTo",
    TIME_TO = "dataType.timeTo",
}
